import { createAction } from '@reduxjs/toolkit';
import { Languages } from 'core/localization/entities';

export const changeSystemLanguage = createAction<Languages>('system/CHANGE_LANGUAGE');
